var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.domainClass(),attrs:{"id":"bin_card_item"},on:{"click":function($event){return _vm.goToCard()}}},[_c('div',{staticClass:"bin-related-card__title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }